export default "__VITE_ASSET__989234a6__"